module.exports = __webpack_public_path__ + "img/0027.261cb170.gif";